import { LinkTheme } from '@/components/Link/theme';
import { GenericSlot } from 'base/components/GenericSlot';
import { BaseSlot } from './slots/base';

export const Link = GenericSlot({ as: BaseSlot, theme: LinkTheme });
